"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Box_1 = __importDefault(require("./Box"));
var boxShadow = function (props) {
    var boxShadows = {
        sm: {
            'box-shadow': props.theme.boxShadows[0]
        },
        md: {
            'box-shadow': props.theme.boxShadows[1]
        },
        lg: {
            'box-shadow': props.theme.boxShadows[2]
        },
        xl: {
            'box-shadow': props.theme.boxShadows[3]
        }
    };
    return boxShadows[props.boxShadowSize];
};
var boxBorder = function (props) { return ({
    border: props.borderWidth === 0
        ? '0'
        : props.borderWidth + "px solid " + props.theme.colors[props.borderColor]
}); };
var Card = styled_components_1["default"](Box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n\n  ", "\n  ", "\n  ", "\n"], ["\n  background-color: ", ";\n\n  ", "\n  ", "\n  ", "\n"])), styled_system_1.themeGet('colors.white'), boxShadow, boxBorder, styled_system_1.borderRadius);
Card.defaultProps = {
    borderColor: 'borderGray',
    borderRadius: 1,
    borderWidth: 1
};
Card.displayName = 'Card';
exports["default"] = Card;
var templateObject_1;
//# sourceMappingURL=Card.js.map